import Client from './Clients/ScrapingToolsClient'

const resource = '/catalog/parser/'

var cachedData=null;

export default {
    get(){
        if(cachedData===null){
            return Client.get(resource).then((response) => {
                cachedData=response;
                return new Promise((resolve,reject) => resolve(response));
            })
        }
        else
            return new Promise((resolve,reject) => resolve(cachedData));
        
    }
}